<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Columnas en sección compuesta Circular</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Aplicaciones</li>
                    <li class="breadcrumb-item active">Columnas en sección compuesta Circular</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">
                    <div class="row ">
                        <!-- Columna izquierda - Botones de formulario -->
                        <div class="col-md-4 mb-2 mb-md-0" style="width: 287.984px;">
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-dark" @click="downloadJSON">
                                    <i class="bi bi-download"></i> Descargar datos de Formulario
                                </button>

                                <button type="button" class="btn btn-info" @click="openUploadFormDataDialog">
                                    <i class="bi bi-upload"></i> Cargar formulario
                                </button>

                                <input type="file" ref="uploadFormDataInput" style="display: none;"
                                    @change="uploadFormData" accept=".json" />
                            </div>
                        </div>

                        <!-- Columna central - Selector de archivo Excel -->
                        <div class="col-md-4 mb-2 mb-md-0" style="width: 289.984px;">
                            <div class="file-upload" style="width: auto;">
                                <!-- Input de archivo oculto -->
                                <input
                                    type="file"
                                    ref="columFileDataPicker"
                                    class="d-none"
                                    @change="handleFileUpload"
                                    accept=".xlsx"
                                />

                                <!-- Botón Excel -->
                                <button class="excel-button" @click.prevent="openColumFileDataPicker">
                                    <svg
                                        fill="#fff"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 50 50"
                                    >
                                        <path
                                            d="M28.8125 .03125L.8125 5.34375C.339844 
                                            5.433594 0 5.863281 0 6.34375L0 43.65625C0 
                                            44.136719 .339844 44.566406 .8125 44.65625L28.8125 
                                            49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 
                                            50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 
                                            30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 
                                            .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 
                                            6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 
                                            29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 
                                            43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 
                                            13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 
                                            21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 
                                            22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 
                                            15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 
                                            28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 
                                            27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 
                                            14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 
                                            20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z"
                                        ></path>
                                    </svg>
                                    &nbsp; Seleccionar archivo Excel
                                </button>

                                <div v-if="columnFileDataName" class="file-name">
                                    📄<span class="ms-3">{{ columnFileDataName }}</span>
                                </div>

                                <span v-else :class="{ 'text-danger': v$.columnFileData.$error }">Unidades de la plantilla:
                                    <br>kN-M: Momentos
                                    <br>kN: Carga Axial
                                    <!-- Mostrar mensaje de error -->
                                    <div v-if="v$.columnFileData.$error" class="text-danger">
                                        {{ validationMessage(v$.columnFileData) }}
                                    </div>
                                </span>
                            </div>
                        </div>

                        <!-- Columna derecha - Imágenes -->
                        <div class="col-md-4" style="width: 414px;">
                            <div class="d-flex -content-end gap-2 flex-wrap">
                                <img :src="bentleyImage" alt="Bentley Local" class="img-fluid" style="max-width: 190px; height: auto;" />
                                <img :src="CircularImage" alt="General Rectangular Column" class="img-fluid" style="max-width: 190px; height: auto;" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body mt-3">

                    <Atom1Loader v-if="loading" />

                    <div class="" v-else>

                        <form class="row g-3">
                            <div class="col-md-12">
                                <h4>Columnas en sección compuesta Circular</h4>
                            </div>

                            <!-- Primera fila -->
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="fc" class="form-control" placeholder="fc" type="number" required :class="{ 'is-invalid': v$.fc.$error }" />
                                    <label>fc (Resistencia a la compresión del concreto MPa)</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input class="form-control" value="0.9" disabled/>
                                    <label>Øv (Factor de seguridad a cortante)</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="Fu" class="form-control" placeholder="Fu" type="number" required :class="{ 'is-invalid': v$.Fu.$error }" />
                                    <label>Fu (Resistencia a la tensión MPa)</label>
                                </div>
                            </div>

                            <!-- Segunda fila -->
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="Es" class="form-control" placeholder="Es" type="number" required :class="{ 'is-invalid': v$.Es.$error }" />
                                    <label>Es (Módulo de elasticidad del acero)</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="Fy" class="form-control" placeholder="Fy" type="number" required :class="{ 'is-invalid': v$.Fy.$error }" />
                                    <label>Fy (Esfuerzo de fluencia Mpa)</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="L_c" class="form-control" placeholder="L_c" type="number" required :class="{ 'is-invalid': v$.L_c.$error }" />
                                    <label>L_c (Longitud de la columna en mm)</label>
                                </div>
                            </div>

                            <!-- Tercera fila -->
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input class="form-control" value="0.75" disabled/>
                                    <label>θ</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="t_nom" class="form-control" placeholder="t_nom" type="number" required :class="{ 'is-invalid': v$.t_nom.$error }" />
                                    <label>t_nom (Espesor nominal de la pared en mm)</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="d" class="form-control" placeholder="d" type="number" required :class="{ 'is-invalid': v$.d.$error }" />
                                    <label>d (Diámetro de la columna en mm)</label>
                                </div>
                            </div>

                            <!-- Botón -->
                            <div class="text-center mt-4">
                                <button class="btn btn-primary" @click.prevent="openModal">Generar Reporte</button>

                                <div><br></div>
                                <div v-if="circularColumnData && showResults" ref="reportContainer">
                                    <button 
                                            class="btn btn-outline-secondary" 
                                            @click="clearFormAndResults"
                                            title="Limpiar formulario para crear un nuevo reporte"
                                        >
                                            <i class="bi bi-arrow-clockwise"></i>
                                            Nuevo Reporte
                                    </button>
                                </div>
                            </div>

                        </form>

                        <!-- Modal -->
                        <div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg">
                                <div class="modal-content">
                                
                                <div class="modal-header">
                                    <h5 class="modal-title" id="confirmModalLabel">¿Está seguro de realizar esta acción?</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                                </div>

                                <div class="modal-body" style="max-height: 400px; overflow-y: auto; white-space: normal;">
                                    <strong>Descargo de Responsabilidad (Disclaimer)</strong><br>
                                    Acuerdo entre el Usuario y los Desarrolladores de la Plataforma de Diseño de Appsmart.
                                    <br><br>
                                    Al acceder y utilizar la plataforma de diseño digital de Appsmart ("la Plataforma"), el usuario acepta los siguientes términos:
                                    
                                    <ol>
                                    <li><strong>Uso bajo responsabilidad del usuario:</strong>  
                                        La Plataforma se proporciona "tal cual", sin garantías expresas ni implícitas por parte de Appsmart o su equipo de desarrollo.
                                        El uso de las funcionalidades, herramientas o resultados generados mediante la Plataforma será responsabilidad exclusiva del usuario.
                                    </li>

                                    <li><strong>Limitación de responsabilidad:</strong>  
                                        Appsmart y sus desarrolladores no se hacen responsables por daños directos, indirectos, incidentales, consecuentes o especiales derivados del uso (o imposibilidad de uso) de la Plataforma.
                                    </li>

                                    <li><strong>Propiedad del contenido:</strong>  
                                        El contenido cargado, editado o creado por los usuarios dentro de la Plataforma sigue siendo propiedad de los usuarios.
                                    </li>

                                    <li><strong>Modificaciones del servicio:</strong>  
                                        Appsmart se reserva el derecho de actualizar, modificar, suspender o discontinuar temporal o permanentemente la Plataforma sin previo aviso.
                                    </li>

                                    <li><strong>Respeto a la propiedad intelectual:</strong>  
                                        El usuario se compromete a no utilizar la Plataforma para infringir derechos de autor, marcas registradas o cualquier otro derecho de terceros.
                                    </li>

                                    <li><strong>Seguridad y datos personales:</strong>  
                                        Aunque Appsmart implementa medidas razonables para la seguridad de la información, no puede garantizar protección total frente a amenazas externas.
                                    </li>

                                    <li><strong>No existe relación contractual adicional:</strong>  
                                        Este Disclaimer no implica la existencia de una sociedad, asociación, empleo o relación de agencia entre el usuario y los desarrolladores.
                                    </li>
                                    
                                    </ol>

                                        <!-- Enlace "Ver más" -->
                                    <p>
                                        <a href="#/disclaimer" target="_blank">Ver más</a>
                                    </p>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                                    <button data-v-6a409483="" type="button" class="btn btn-primary" @click="generateGraph" data-bs-dismiss="modal">Sí, generar reporte</button>
                                </div>

                                </div>
                            </div>
                        </div>



                        <!---->


                        <!-- Reporte Columna Circular -->
                        <div class="col-12 mt-4" v-if="circularColumnData && showResults" ref="reportContainer">

                            <h2 class="text-xl font-semibold mb-4">Resultados</h2>

                            <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="800px"></iframe>

                        </div>

                    </div>

                </div>
            </div>
        </section>
    </MainLayout>
</template>

<script>
import useValidate from '@vuelidate/core';
import { required, helpers  } from '@vuelidate/validators';

import MainLayout from '@/layouts/MainLayout';

import validatorMixin from '@/mixins/validatorMixin';
import toastMixin from '@/mixins/toastMixin';
import accountMixin from '@/mixins/accountMixin';

//imagenes
import bentleyImage from '@/assets/images/Bentley-LocalCSystem.png';
import CircularImage from '@/assets/images/PTEC1.png';

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

import axios from "axios";

import { nextTick } from 'vue';
import * as bootstrap from 'bootstrap';

import katex from 'katex';
import 'katex/dist/katex.min.css'; // Importa los estilos CSS de KaTeX


export default {

    mixins: [validatorMixin, toastMixin, accountMixin],

    name: 'App1',

    components: {
        MainLayout,
        Atom1Loader
    },

    data() {

        return {

            v$: useValidate({ $stopPropagation: true }),

            loading: false,

            showResults: false,

            columnFileData: null,
            columnFileDataName: null,

            columnType: 0,

            bentleyImage,
            CircularImage,
            
            Fu: null,
            fy: null,
            fc: null,
            Øv: 0.9,
            Pu: null,
            H: null,
            B: null,
            t: null,
            Es: null,
            Zs: null,
            Zs_d: null,
            I_sy: null,
            I_sx: null,
            L: null,

            Fy: null,
            L_c: null,
            θ: 0.75,
            t_nom: null,
            d:  null,

            image64_1: '',
            image64_2: '',

            pdfUrl: null,
            pdf_base64: null,


            rectangularColumnContent: null,

            circularColumnData: {

                part1: null,              
                image64_1: null,
                image64_2: null,
                part2: null,              
                image64_3: null,
                image64_4: null,
                part3: null,
                tablas: null,        
            },            
        };
    },

    computed: {
  formattedResults() {
    if (!this.circularColumnData) return '';

    let result = '';

    // Procesar part_1
    if (this.circularColumnData.part1) {
      result += `<div class="mb-6" style="page-break-inside: avoid;">
        <h3 class="text-lg font-semibold mb-2">Propiedades de diseño</h3>
        <div class="bg-gray-50 p-4 rounded">
          ${this.circularColumnData.part1.replace(/\n/g, '<br>')}
        </div>
      </div>`;
    }

    // Procesar part_2
    if (this.circularColumnData.part2) {
      result += `<div class="mb-6" style="page-break-inside: avoid;">
        <h3 class="text-lg font-semibold mb-2">Resistencia crítica</h3>
        <div class="bg-blue-50 p-4 rounded font-mono">
          ${this.circularColumnData.part2.replace(/\n/g, '<br>')}
        </div>
      </div>`;
    }

    // Procesar part_3
    if (this.circularColumnData.part3) {
      result += `<div class="mb-6" style="page-break-inside: avoid;">
        <h3 class="text-lg font-semibold mb-2">Valores calculados</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          ${this.circularColumnData.part3.split('\n').map(line => 
            `<div class="bg-white p-2 border-b">${line}</div>`
          ).join('')}
        </div>
      </div>`;
    }

    // Procesar tablas con validación robusta
    const tablasRaw = this.circularColumnData.tablas;
    if (typeof tablasRaw === 'string' && tablasRaw.trim()) {
      const tablas = tablasRaw.trim().split(/\n\s*\n/);
      result += tablas.map((tablaStr) => {
        if (typeof tablaStr !== 'string') return '';

        const lines = tablaStr.trim().split('\n').filter(Boolean);
        if (lines.length < 2) return ''; // Necesitamos al menos título + encabezados

        const title = `<h3 class="text-lg font-semibold mb-2" style="page-break-inside: avoid;">${lines[0]}</h3>`;

        const headers = typeof lines[1] === 'string'
          ? lines[1].trim().split(/\s{2,}/)
          : [];

        const rows = lines.slice(2).map(line => {
          if (typeof line !== 'string') return '';
          const cols = line.trim().split(/\s{2,}/);
          return `<tr>${cols.map(c => `<td class="border px-4 py-2">${c}</td>`).join('')}</tr>`;
        });

        return `
          <div class="mb-6" style="page-break-inside: avoid;">
            ${title}
            <div class="overflow-x-auto">
              <table class="w-full border-collapse">
                <thead class="bg-gray-100">
                  <tr>${headers.map(h => `<th class="border px-4 py-2 font-medium">${h}</th>`).join('')}</tr>
                </thead>
                <tbody>${rows.join('')}</tbody>
              </table>
            </div>
          </div>`;
      }).join('');
    }

    return result;
  }


},

    validations() {
    return {
        columnFileData: {
            required: helpers.withMessage("El archivo es obligatorio", required),
            validFormat: helpers.withMessage(
                "Solo se permiten archivos .xlsx",
                (file) => file && file.name.endsWith(".xlsx")
            ),
            maxSize: helpers.withMessage(
                "El archivo no debe superar los 5MB",
                (file) => file && file.size <= 5 * 1024 * 1024
            ),
        },
        Fu: { required },
        fc: { required },
        Øv: { required },
        Es: { required },

        // Solo campos de columna circular
        Fy: { required },
        L_c: { required },
        θ: { required },
        t_nom: { required },
        d: { required },
    };
},

    async mounted() {

    },

    methods: {

    reemplazarConLatex(texto) {
        const mapeo = {
            'λ_max': '\\lambda_{max}',
            'λ_r': '\\lambda_{r}',
            'λ_p': '\\lambda_{p}',
            'λ': '\\lambda', // Asegúrate de que se reemplace correctamente
            'θ': '\\theta',
            'Ø': '\\varnothing',
            'σ': '\\sigma',
            'ϕ': '\\phi',
            'Δ': '\\Delta',
        };


        // Ordenar las claves por longitud descendente
        const clavesOrdenadas = Object.keys(mapeo).sort((a, b) => b.length - a.length);

        clavesOrdenadas.forEach(clave => {
            const valor = mapeo[clave];
            const regex = new RegExp(clave.replace(/([.*+?^${}()|[\]\\])/g, '\\$1'), 'g');
            texto = texto.replace(regex, `$${valor}$`);
        });

        return texto;
    },

    openModal() {
        nextTick(() => {
            const modalElement = document.getElementById('confirmModal');
            if (modalElement) {
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
            } else {
            console.error("Modal no encontrado en el DOM.");
            }
        });
    },

    openColumFileDataPicker() {
        this.$refs.columFileDataPicker.click();
    },

    handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        console.log("📌 Archivo seleccionado:", file.name);
        this.columnFileData = file;
        this.columnFileDataName = file.name;
    },

    fixBase64(image) {
        if (image && !image.startsWith('data:image/png;base64,')) {
            return 'data:image/png;base64,' + image;
        }
        return image;
    },

    clearFormAndResults() {
    // Limpiar campos del formulario
    this.Fu = null;
    this.Fy = null;
    this.fc = null;
    this.Øv = 0.9;
    this.θ = 0.75;
    this.H = null;
    this.B = null;
    this.t_nom = null;
    this.Es = null;
    this.L = null;
    this.L_c = null; // Agregado este campo que faltaba
    this.d = null;   // Agregado este campo que faltaba

    // Limpiar archivo seleccionado
    this.columnFileData = null;
    this.columnFileDataName = null;
    
    // Limpiar AMBOS inputs de archivo
    if (this.$refs.columFileDataPicker) {
        this.$refs.columFileDataPicker.value = '';
    }
    
    // ⭐ ESTA ES LA LÍNEA CLAVE QUE FALTABA ⭐
    if (this.$refs.uploadFormDataInput) {
        this.$refs.uploadFormDataInput.value = '';
    }

    // Limpiar datos de resultados
    this.circularColumnData = { // Cambiado de rectangularColumnData a circularColumnData
        part1: null,              
        image64_1: null,
        image64_2: null,
        part2: null,              
        image64_3: null,
        image64_4: null,
        part3: null,
        tablas: null,        
    };

    // Limpiar PDF
    this.pdfUrl = null;
    this.pdf_base64 = null;

    // Ocultar resultados
    this.showResults = false;

    // Limpiar validaciones
    this.v$.$reset();

    // Mostrar notificación de confirmación
    this.showNotification({
        title: 'Formulario limpiado',
        description: 'Todos los campos han sido limpiados. Puede crear un nuevo reporte.',
        type: 'success',
        timeout: 3,
    });

    // Scroll hacia el inicio del formulario
    this.$nextTick(() => {
        const formElement = document.querySelector('.card-body');
        if (formElement) {
            formElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
    });
    },

    async generateGraph() {
        // Asignar valores fijos antes de validar y enviar
        this.Øv = 0.9;
        this.θ = 0.75;

        this.v$.$validate();

        if (this.v$.$error) {
            this.showNotification({
                title: 'asegúrese de cargar la plantilla de excel o rellenar todos los campos',
                description: '',
                type: 'danger',
                timeout: 4,
            });
            return;
        }

        this.loading = true;

        const data = {
            Fu: this.Fu,
            fc: this.fc,
            Øv: this.Øv,
            Es: this.Es,
            Fy: this.Fy,
            L_c: this.L_c,
            θ: this.θ,
            t_nom: this.t_nom,
            d: this.d,
            column_type: 1,
        };

        const cleanData = Object.fromEntries(
            Object.entries(data).filter(([, value]) => value !== null && value !== undefined && value !== '')
        );

        const formData = new FormData();
        formData.append("column_file_data", this.columnFileData);

        for (const key in cleanData) {
            formData.append(key, cleanData[key]);
        }

        const headers = {
            Authorization: `Bearer ${this.accountUser.token}`,
            "Content-Type": "multipart/form-data",
        };

        try {
            const response = await axios.post(`${this.$env.API_BASE_URL}apps/app1/`, formData, { headers });
            const responseData = response.data.result || response.data;

            this.circularColumnData = {
                part1: responseData.part_1 ? this.formatText(responseData.part_1) : 'No hay datos',
                part2: responseData.part_2 ? this.formatText(responseData.part_2) : 'No hay datos',
                part3: responseData.part_3 ? this.formatText(responseData.part_3) : 'No hay datos',
                tablas: responseData.tablas ? this.formatText(responseData.tablas) : 'No hay datos',
                image64_1: this.fixBase64(responseData.image64_1),
                image64_2: this.fixBase64(responseData.image64_2),
                image64_3: this.fixBase64(responseData.image64_3),
                image64_4: this.fixBase64(responseData.image64_4)
            };

            if (responseData.pdf_base64) {
            this.pdf_base64 = responseData.pdf_base64;
            this.pdfUrl = `data:application/pdf;base64,${responseData.pdf_base64}`;
        }

            this.showResults = true;
            this.loading = false;
        } catch (error) {
            console.error('Error:', error);
            this.loading = false;
            this.showNotification({
                title: 'Error',
                description: error.message,
                type: 'danger',
                timeout: 5
            });
        }
    },

    formatText(text) {
    const lines = text.split('\n');
    let output = '';
    let inTable = false;
    let tableData = [];
    let tableTitle = '';
    let tableCounter = 0;

    lines.forEach(line => {
        if (line.startsWith('Tabla ')) {
            // Si hay una tabla previa, la generamos
            if (inTable && tableData.length > 0) {
                output += this.generateHtmlTable(tableData, tableTitle, tableCounter);
                tableData = [];  // Reiniciamos la tabla
            }

            // Establecemos el nuevo título de la tabla
            const parts = line.split(':');
            tableTitle = parts[1] ? parts[1].trim() : '';
            tableCounter++;
            inTable = true;
        } else if (inTable) {
            // Continuamos recopilando las filas de la tabla
            tableData.push(line.trim());
        } else {
            // El resto del texto se convierte en párrafos normales
            output += `<p>${line}</p>`;
        }
    });

    // Al final, generamos la última tabla si es necesario
    if (inTable && tableData.length > 0) {
        output += this.generateHtmlTable(tableData, tableTitle, tableCounter);
    }

    return output;
    },

    generateHtmlTable(tableLines, title, index) {
        if (!tableLines || tableLines.length < 2) {
            return '';
        }

        const escapeHtml = (text) => {
            const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
            return text.replace(/[&<>"']/g, m => map[m]);
        };

        const headers = tableLines[0].split(/\s{2,}/).map(h => escapeHtml(h.trim()));
        const rows = tableLines.slice(1).map(row => {
            const cols = row.split(/\s{2,}/).map(c => escapeHtml(c.trim()));
            return `<tr>${cols.map(col => `<td class="border px-2 py-1">${col}</td>`).join('')}</tr>`;
        }).join('');

        // Insertamos un encabezado vacío al principio del array de encabezados
        const shiftedHeaders = ['', ...headers];

        return `
            <h4 class="text-lg font-semibold mb-2">Tabla ${index}: ${escapeHtml(title)}</h4>
            <table class="table-auto border-collapse w-full mb-4 border">
                <thead><tr>${shiftedHeaders.map(h => `<th class="border px-2 py-1 font-medium">${h}</th>`).join('')}</tr></thead>
                <tbody>${rows}</tbody>
            </table>
        `;
    },

    renderKatexToImage(mathTex, callback) {
        try {
            const html = katex.renderToString(mathTex, {
                output: 'html',
                displayMode: mathTex.startsWith('$$'),
                throwOnError: false,
                trust: true,
            });

            const parser = new DOMParser();
            const svg = parser.parseFromString(html, 'image/svg+xml').documentElement;
            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            const svgData = new XMLSerializer().serializeToString(svg);

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();
            const scale = 3;
            const bbox = svg.getBBox();
            canvas.width = bbox.width * scale;
            canvas.height = bbox.height * scale;
            ctx.scale(scale, scale);

            img.onload = () => {
                ctx.drawImage(img, 0, 0);
                callback(canvas.toDataURL('image/png', 1.0));
            };

            img.onerror = (error) => {
                console.error('Error al cargar SVG:', error);
                callback('');
            };

            img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
                `<svg xmlns="http://www.w3.org/2000/svg" width="${bbox.width}" height="${bbox.height}" viewBox="${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}">${svgData}</svg>`
            );

        } catch (error) {
            console.error('Error en renderKatexToImage:', error);
            callback('');
        }
    },


    downloadJSON() {
        const formData = {
            Fu: this.Fu,
            fc: this.fc,
            Øv: 0.9, // Valor fijo
            Es: this.Es,
            Fy: this.Fy,
            L_c: this.L_c,
            θ: 0.75, // Valor fijo
            t_nom: this.t_nom,
            d: this.d,
        };

        const jsonStr = JSON.stringify(formData, null, 2);
        const blob = new Blob([jsonStr], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'formData.json';
        link.click();
    },

    openUploadFormDataDialog() {
        this.$refs.uploadFormDataInput.click();
    },

    uploadFormData(event) {
        const file = event.target.files[0];

        if (file && file.type === 'application/json') {
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const data = JSON.parse(reader.result);
                    this.Fu = data.Fu || null;
                    this.fc = data.fc || null;
                    this.Øv = 0.9; // Valor fijo
                    this.Es = data.Es || null;
                    this.Fy = data.Fy || null;
                    this.L_c = data.L_c || null;
                    this.θ = 0.75; // Valor fijo
                    this.t_nom = data.t_nom || null;
                    this.d = data.d || null;
                } catch (error) {
                    this.showNotification({
                        title: 'Error al leer el archivo JSON.',
                        description: '',
                        type: 'danger',
                        timeout: 4,
                    });
                }
            };
            reader.readAsText(file);
        } else {
            this.showNotification({
                title: 'Por favor, seleccione un archivo JSON válido.',
                description: '',
                type: 'danger',
                timeout: 4,
            });
        }
    }
}
    
};

</script>

<style scoped>

/* Estilos generales del switch */
.filter-switch {
  border: 2px solid #4683b5;
  border-radius: 30px;
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  max-width: 100%; /* Evita desbordamiento */
  width: 100%; /* Permite que se ajuste automáticamente */
  min-width: 250px; /* Evita que se haga demasiado pequeño */
  overflow: hidden;
  padding: 0 5px;
  box-sizing: border-box; /* Asegura que el padding no afecte el ancho */
}

/* Ocultar los radio buttons */
.filter-switch input {
  display: none;
}

/* Estilos de las etiquetas */
.filter-switch label {
  flex: 1;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px; /* Reducido para mejorar en pantallas pequeñas */
  transition: color 0.3s;
  color: #7d7d7d;
  padding: 10px;
}

/* Fondo azul deslizante */
.filter-switch .background {
  position: absolute;
  width: 48%; /* Ajuste dinámico */
  height: 38px;
  background-color: #4683b5;
  top: 4px;
  left: 4px;
  border-radius: 30px;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1;
}


/* Cambio de color del texto cuando está seleccionado */
.filter-switch input:checked + label {
  color: #fff;
  font-weight: bold;
}

/* Cambio de color del texto cuando está seleccionado */
.filter-switch label.active {
  color: #fff;
  font-weight: bold;
  z-index: 2;
}
/* Responsivo */
@media (max-width: 500px) {
  .filter-switch {
    min-width: 200px;
  }
  
  .filter-switch label {
    font-size: 14px; /* Reducir aún más el tamaño en móviles */
  }
}


/* ********** EXCEL BUTTON *********** */

/* Estilos del botón */
.excel-button {
  background-color: #217346;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.3s;
}

.excel-button:hover {
  background-color: #1a5a30;
}

/* Ícono de Excel */
.excel-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

/* Nombre del archivo seleccionado */
.file-name {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.pdf-graphic {
  page-break-before: always; /* Salto de página antes de cada gráfico */
}


</style>